'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var categoryOverviewComponent = exports.categoryOverviewComponent = {
    template: require('./overview.html'),
    bindings: {
        category: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "productOverviewService", "Enums", "common", "$stateParams", "gettextCatalog", "Analytics", function controller($scope, productOverviewService, Enums, common, $stateParams, gettextCatalog, Analytics) {
        'ngInject';

        var vm = this;
        vm.productOverviewModel = null;
        vm.$onInit = init;
        vm.initialLoad = null;
        vm.onFilterChange = onFilterChange;

        function init() {

            common.setTitle(gettextCatalog.getString('Products'));
            common.navigationMenu.setProductsActive();

            if (!$stateParams.categoryId) {
                vm.categoryId = 0;
            } else {
                vm.categoryId = $stateParams.categoryId;
            }

            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/products/category/' + vm.categoryId, gettextCatalog.getString('Products'));

            //todo put in resolve
            if ($stateParams.noReloadFilter) {
                vm.productOverviewModel = productOverviewService.getProductOverviewModel();
            } else {
                vm.productOverviewModel = productOverviewService.init(Enums.searchContext.category.id);
            }
            productOverviewService.getProductsByCategory($stateParams.noReloadFilter ? false : true, vm.productOverviewModel, vm.categoryId).then(function (model) {
                vm.productOverviewModel = model;
                productOverviewService.setProductOverviewModel(vm.productOverviewModel);
                listenForLocationChangeSuccess();
            });
        }

        function listenForLocationChangeSuccess() {
            $scope.$on('$locationChangeSuccess', function () {
                productOverviewService.getProductsByCategory(false, vm.productOverviewModel, vm.categoryId).then(function (model) {
                    vm.productOverviewModel = model;
                });
            });
        }

        function onFilterChange() {
            productOverviewService.setProductOverviewModel(vm.productOverviewModel);
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/category/overview.js
// module id = 900
// module chunks = 0